module.exports = __webpack_public_path__ + "static/media/11.7e445b06.jpg";